export class AppSettings {
  //static API_BASE_URL: string = "https://localhost:44311/";
  //static API_BASE_URL: string = "http://103.92.121.94:12561/";
  //static API_BASE_URL: string = "https://staging-api.kangoexpress.com/";
  static API_BASE_URL: string = "https://api.kangoexpress.com/";

  static RE_CAPTCHA_SITEKEY = "6LdB7zwqAAAAAH-H2f3myhXy6FuOajkhxievaQbf"; // reCAPTCHA V2 invisible
}
